import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getCookie } from "../../helpers/cookie";
import { getUserAction } from "../../redux/actions/loginAction";
import { Box } from "@mui/material";
import { Triangle } from "react-loader-spinner";

// ==============================|| MINIMAL LAYOUT ||============================== //

export default function MinimalLayout() {
  const login = useSelector((state) => state.login);
  const userRoleRouters = useSelector((state) => state.userRoleRouters);
  const userRoute = userRoleRouters?.landingPage;

  const dispatch = useDispatch();
  const location = useLocation();

  const token = getCookie("accessToken");

  useEffect(() => {
    if (token) {
      dispatch(getUserAction());
    }
  }, [dispatch, token]);

  const authPaths = [
    "/",
    "/login",
    "/register",
    "/registration",
    "/registration/existingregistration",
    "/changepassword",
  ];
  const isAuthRoute = authPaths.includes(location.pathname.toLowerCase());

  if (token && isAuthRoute) {
    const landingPath = userRoute?.[0]?.navPath || "/";
    const loading = login?.loading || userRoleRouters?.loading;

    if (loading && !userRoute?.[0]?.navPath) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Triangle
            visible={true}
            height="150"
            width="200"
            color="#4076f5"
            ariaLabel="triangle-loading"
          />
        </Box>
      );
    }

    return <Navigate to={landingPath} replace />;
  }

  return <Outlet />;
}
